<template>
  <div class="text-center">
    <v-img
      width="500"
      class="mx-auto"
      contain
      src="~@/assets/images/mainpage.gif"
    />
    <h1 class="dastnevis red--text my-7">
      آدرس نادرست
    </h1>
    <v-alert border="left" colored-border type="error" elevation="2">
      این پورتال وجود ندارد؛ لطفا آدرس صحیح پورتال خود را وارد نمایید
    </v-alert>
  </div>
</template>
<script>
export default {
  name: "portal-not-exist-component",
  data() {
    return {};
  }
};
</script>
